import { motion } from 'framer-motion'

import { cn } from 'src/shared/utils/cn'

interface PulsatingDotsProps {
  className?: string
}

export default function PulsatingDots({ className }: PulsatingDotsProps) {
  return (
    <div className="flex items-center justify-center">
      <div className="flex space-x-2">
        <motion.div
          className={cn('size-2 rounded-full bg-current', className)}
          animate={{
            scale: [1, 1.5, 1],
            opacity: [0.5, 1, 0.5],
          }}
          transition={{
            duration: 1,
            ease: 'easeInOut',
            repeat: Infinity,
          }}
        />
        <motion.div
          className={cn('size-2 rounded-full bg-current', className)}
          animate={{
            scale: [1, 1.5, 1],
            opacity: [0.5, 1, 0.5],
          }}
          transition={{
            duration: 1,
            ease: 'easeInOut',
            repeat: Infinity,
            delay: 0.3,
          }}
        />
        <motion.div
          className={cn('size-2 rounded-full bg-current', className)}
          animate={{
            scale: [1, 1.5, 1],
            opacity: [0.5, 1, 0.5],
          }}
          transition={{
            duration: 1,
            ease: 'easeInOut',
            repeat: Number.POSITIVE_INFINITY,
            delay: 0.6,
          }}
        />
      </div>
    </div>
  )
}
